import axios from 'axios'

/**
 * RestAPIへの通信を行う
 * @param {*} url 先頭に/を付けたパスを定義する
 * @param {*} idToken
 * @param {*} params
 */
export function restApiRequest(baseUrl, url, idToken, option = null) {
  let httpClient = axios.create({
    baseURL: baseUrl,
    headers: {
      Authorization: idToken,
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  return httpClient.get(url, option)
}

/**
 * RestAPIへの通信を行う
 * @param {*} url 先頭に/を付けたパスを定義する
 * @param {*} idToken
 * @param {*} params
 */
export function restApiRequestPost(baseUrl, url, idToken, params = null) {
  let httpClient = axios.create({
    baseURL: baseUrl,
    headers: {
      Authorization: idToken,
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  return httpClient.post(url, params)
}

/**
 * RestAPIへの通信から CSV ダウンロードを行う
 * @param {*} url 先頭に/を付けたパスを定義する
 * @param {*} idToken
 * @param {*} option
 */
export function restApiRequestDownload(baseUrl, url, idToken, option = null) {
  let httpClientDl = axios.create({
    baseURL: baseUrl,
    headers: {
      Authorization: idToken,
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    responseType: 'blob'
  })
  return httpClientDl.get(url, option)
}

/**
 * CSV ダウンロードを行う
 * @param {*} url 先頭に/を付けたパスを定義する
 * @param {*} idToken
 * @param {*} params
 */
export function postRequestFileDownload(baseUrl, url, idToken, params = null) {
  let httpClientDl = axios.create({
    baseURL: baseUrl,
    headers: {
      Authorization: idToken,
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    responseType: 'blob'
  })
  return httpClientDl.post(url, params)
}

/**
 * エラーコードからメッセージを取得する
 * @param {*} errorCode エラーコード
 */
export function getErrorMessage(errorCode) {
  let errorMessage = ''
  switch (errorCode) {
    case 'mainte':
      errorMessage = 'commons.mainte'
      break
    case 'system.error':
      errorMessage = 'commons.restapi.system.error'
      break
    case 'break_count_total.error':
    case 'cpxreport_price.error':
      errorMessage = 'commons.restapi.system.fatal.error'
      break
    case 'permission.expiration.error':
      errorMessage = 'commons.restapi.permission.expiration.error'
      break
    case 'agency_id.not.exist':
    case 'advertiser_id.not.exist':
    case 'campaign_id.not.exist':
    case 'campaign_period_id.not.exist':
    case 'private_brand_id.error':
      errorMessage = 'commons.restapi.data.notfound'
      break
    case 'agency_id.empty':
    case 'agency_id.not.number':
    case 'advertiser_id.empty':
    case 'advertiser_id.not.number':
    case 'campaign_id.empty':
    case 'campaign_id.not.number':
    case 'campaign_period_id.empty':
    case 'campaign_period_id.not.number':
    case 'target_month.not.number':
    case 'ids_invalid_format.error':
    case 'date_invalid_format.error':
    case 'required_check.error':
    case 'unmatch_item.error':
      errorMessage = 'commons.restapi.data.notfound'
      break
    case 'permission.error':
      errorMessage = 'commons.restapi.permission.error'
      break
    default:
      errorMessage = 'commons.restapi.system.error'
      break
  }
  return errorMessage
}
